import { SeriesState } from './types';

export const initialState: SeriesState = {
  seriesList: null,
  totalSeries: 0,
  currentSeries: null,
  loadingSeriesList: false,
  loadingCurrentSeries: false,
  seriesError: false,
  topDrawerOpen: false,
  seriesListInitialLoaded: false,
};
